import React, { useState } from "react";
import { T, AWARD_COLORS, fmt } from "./theme";
import { SectionHeader, Card, Input, Btn, Note, PilulaAward } from "./ui";
import { Icon } from "./Icons";

// ═══════════════════════════════════════════════════════════════════════
// METAS INDIVIDUAIS — admin edita metas semanais por Award
// Cada nível de award tem sua própria meta de volume R$ e ativações.
// ═══════════════════════════════════════════════════════════════════════

const ORDEM_AWARDS = ["cafe", "bronze", "silver", "gold", "platinum", "diamond"];

export default function MetasIndividuais({ metasIndividuais, setMetasIndividuais }) {
  const [editado, setEditado] = useState(metasIndividuais);
  const [saved, setSaved] = useState(false);

  function salvar() {
    setMetasIndividuais(editado);
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  }

  function updateMeta(awardId, campo, valor) {
    setEditado({
      ...editado,
      [awardId]: { ...editado[awardId], [campo]: valor },
    });
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <SectionHeader
        title="Metas Individuais"
        subtitle="Define metas semanais de referência por Award. Admin pode revisar anualmente."
        icon={<Icon.star size={24} />}
        right={
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            {saved && <span style={{ fontSize: 11, color: T.ok, fontWeight: 600 }}>✓ Salvo!</span>}
            <Btn onClick={salvar} icon={<Icon.check size={14} />}>Salvar alterações</Btn>
          </div>
        }
      />

      <Note tone="info" icon={<Icon.info size={14} />}>
        <b>Como funciona:</b> Cada corretor recebe automaticamente a meta do seu Award Vitalício. Um Golden vê a meta Golden; um Diamond vê a meta Diamond. Essas metas são <b>referência individual</b> — a mesma venda/ativação do corretor já alimenta as metas de Time, Regional e Nacional. Metas mensais = 4× semanal. Anuais = 52× semanal.
      </Note>

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {ORDEM_AWARDS.map(awardId => {
          const meta = editado[awardId] || { nome: awardId, volume: 0, ativacoes: 0 };
          const color = AWARD_COLORS[awardId];

          return (
            <Card key={awardId} style={{
              borderLeft: `4px solid ${color.fg}`,
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14, flexWrap: "wrap", gap: 10 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <PilulaAward awardId={awardId} size="md" />
                </div>
                <div style={{ fontSize: 11, color: T.textSub }}>
                  Mensal: {fmt.brl(meta.volume * 4)} · {meta.ativacoes * 4} ativações · Anual: {fmt.brl(meta.volume * 52)} · {meta.ativacoes * 52} ativações
                </div>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }} className="grid-2-to-1">
                <Input
                  label="💰 Meta Volume por semana (R$)"
                  type="number"
                  value={meta.volume}
                  onChange={e => updateMeta(awardId, "volume", Number(e.target.value))}
                  hint={`Atual: ${fmt.brl(meta.volume)}`}
                />
                <Input
                  label="👥 Meta Ativações por semana"
                  type="number"
                  value={meta.ativacoes}
                  onChange={e => updateMeta(awardId, "ativacoes", Number(e.target.value))}
                  hint={meta.ativacoes === 0 ? "Sem ativações exigidas" : `${meta.ativacoes} ativações/semana`}
                />
              </div>
            </Card>
          );
        })}
      </div>

      <Card soft>
        <div style={{ fontSize: 11, color: T.textSub, textTransform: "uppercase", letterSpacing: 1, fontWeight: 600, marginBottom: 10 }}>
          💡 Dica de configuração
        </div>
        <div style={{ fontSize: 12, color: T.textSec, lineHeight: 1.7 }}>
          As metas devem ser <b>progressivas mas atingíveis</b>. Um corretor que acabou de virar Golden precisa sentir que a meta Golden é desafiadora mas possível. Se a meta for muito alta, ele desanima; se for muito baixa, perde o sentido.
          <br /><br />
          <b>Sugestão:</b> olhe o volume semanal médio atual dos corretores do nível e defina a meta como <b>110–120% dessa média</b>. Assim, quem está no ritmo bate tranquilo, quem está abaixo se esforça, quem está acima celebra.
        </div>
      </Card>
    </div>
  );
}
